<template>
  <div id="app" v-bind:style="{ backgroundColor: color}">
    <div v-parallax="0.5" class="parallax-header">
      <img src="./assets/logo.png" id="logo-image"/>
    </div>
    <Podcast
      v-for='Podcast in Podcasts.slice().reverse()'
      v-bind:key='Podcast.id'
      v-bind:title='Podcast.title'
      v-bind:subtitle='Podcast.subtitle'
      v-bind:description='Podcast.description'
      v-bind:youtube='Podcast.youtube_url'
      v-bind:episodeNumber='Podcast.episode_number'
      v-if="(new Date(1970, 0, 1).setSeconds(Podcast.release_date.seconds)) < new Date()">
    </Podcast>
     <a href="https://squareup.com/store/publicaccess" target="_blank">
      <div><fab
        v-on:click="test"
        :main-icon="fabIcon"
        :bg-color="fabColor"
        :fixed-tooltip = "true"
        :main-tooltip="'Buy some of our stuff'"
        @cache="cache"
        @alertMe="alert"
      ></fab>
      </div>
    </a>
  </div>
</template>

<script>
import Podcast from '@/components/Podcast'
import { db } from './main'
import fab from 'vue-fab'


var colors = [
  '#d2eaef',
  '#e2efd2',
  '#efebd2',
  '#efe0d2',
  '#efd2d2',
  '#efefd2',
  '#d2efe0',
  '#d2edef',
  '#d2deef',
  '#d2d2ef',
  '#ddd2ef',
  '#e6d2ef',
  '#edd2ef',
  '#efd2e5',
  '#efd2db'
]

var fab_colors = [
  '#42dff4',
  '#6140f7',
  '#f740f7',
  '#f7c340',
  '#f74040'
]

export default {
  name: 'App',
  components: {
    Podcast, 
    fab
  },
  firestore () {
    return {
      Podcasts: db.collection('episodes').orderBy('release_date')
    }
  },
  data () {
    return {
      color: colors[Math.floor(Math.random() * colors.length)],
      Podcasts: [],
      fabColor: fab_colors[Math.floor(Math.random() * fab_colors.length)],
      fabIcon: "shopping_cart",
      fabActions: [
        {
            name: 'cache',
            icon: 'cached'
        },
        {
            name: 'alertMe',
            icon: 'add_alert'
        }
      ]
    }
  },
  methods: {
    test(e){
      e.preventDefault();
    },
    cache(){
          console.log('Cache Cleared');
      },
      alert(){
          alert('Clicked on alert icon');
      }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0px !important;
  padding-bottom:40px;
}
html{
  margin-top:-25px !important;
  padding:0px !important;
}
body{
  margin:0px !important;
  padding:0px !important;
}
#logo-image{
  width:50%;
  margin-bottom:5%;
}
.parallax-header{
  z-index:-1;
  height:30%;
  margin-top:calc(-1 * 18vh);
  margin-bottom:18vh;
}
.podcast-episode{
  width:80%;
  margin-left:auto !important;
  margin-right:auto !important;
  transform: translate3d(0px, 0px, 10px) !important;
}
.fab-tooltip{
  font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
  font-size:20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue